import { Paper } from '@mui/material';
import {
  useSubmitConfigurationMutation,
  useUpdateStoreConfigurationMutation,
} from 'api/ml-service/ml-service';
import IncForm from 'components/forms/inc-form/inc-form.component';
import MLConfigurationForm from 'components/forms/ml-configuration-form/ml-configuration-form.component';
import { useMlConfigurationsForm } from 'components/forms/ml-configuration-form/ml-configuration-form.hooks';
import IncPageCancelButton from 'components/inc-page/inc-page-footer/inc-page-cancel-button/inc-page-cancel-button.component';
import IncPageFooter from 'components/inc-page/inc-page-footer/inc-page-footer.component';
import IncPageSaveButton from 'components/inc-page/inc-page-footer/inc-page-save-button/inc-page-save-button.component';
import { useHasPermission } from 'hooks/authorization.hooks';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RecommendationsSettingsConfigurations = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { form, queryResult, handleReset } = useMlConfigurationsForm();
  const [submitConfiguration] = useSubmitConfigurationMutation();
  const [updateLocationConfiguration] = useUpdateStoreConfigurationMutation();
  const hasEditPermission = useHasPermission('EDIT_RECOMMENDATIONS_SETTINGS');

  useEffect(() => {
    handleReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onValid = async data => {
    const body = {
      mainCount: data.mainCount,
      sideCount: data.sideCount,
      beverageCount: data.beverageCount,
      dessertCount: data.dessertCount,
      maxRuleRecommendations: data.maxRuleRecommendations,
      maxRecommendations: data.maxRecommendations,
    };

    await submitConfiguration(body);

    let locations;
    if (data.locationIds[0].id === 'ALL') {
      locations = queryResult.data[1].locations.map(loc => ({
        ...loc,
        locationEnabled: true,
      }));
    } else {
      locations = queryResult.data[1].locations.map(loc => {
        if (
          !!data.locationIds.find(location => loc.locationId === location.id)
        ) {
          return { ...loc, locationEnabled: true };
        }
        return { ...loc, locationEnabled: false };
      });
    }
    await updateLocationConfiguration({
      locations,
    });
    enqueueSnackbar(t('page.menus.recommendations.settings.saved'), {
      severity: 'success',
    });
  };

  return (
    <IncForm formMethods={form} onSubmit={form.handleSubmit(onValid)}>
      <Paper sx={{ p: 2, mb: 2 }} elevation={3}>
        <MLConfigurationForm />
      </Paper>
      {hasEditPermission && (
        <IncPageFooter>
          <IncPageSaveButton
            isLoading={queryResult.isLoading || form.formState.isSubmitting}
            disabled={!form.formState.isDirty}
          />
          <IncPageCancelButton
            disabled={!form.formState.isDirty}
            onClick={handleReset}
          />
        </IncPageFooter>
      )}
    </IncForm>
  );
};

export default RecommendationsSettingsConfigurations;
